import { useQuery } from '@tanstack/react-query';
import { changeTemplateApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useChangeTemplate(id: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.organization.changeTemplateDetail(id ?? ''),
    queryFn: ({ signal }) =>
      changeTemplateApiClient.getById(id!, toCancelToken(signal)),
    enabled: !!id,
    staleTime: 0,
    meta: { errorContext: 'change template detail' },
  });
}
